
import ServiceCard from '../../../components/base/ServiceCard';

export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-magic-line',
      title: 'Espectáculo Completo',
      description: 'Presentación teatral estructurada con narrativa completa, ideal para teatros y centros culturales. Incluye una selección diversificada de ilusiones, interacciones con el público y momentos de reflexión, creando una experiencia inmersiva y memorable.',
      features: [
        'Narrativa teatral estructurada',
        'Selección diversificada de ilusiones',
        'Interacciones con el público',
        'Momentos de reflexión integrados',
        'Experiencia inmersiva y memorable'
      ]
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'Presentación Educativa',
      description: 'Formato adaptado para instituciones de enseñanza, con contenido pedagógico específico para cada grupo de edad. Combina entretenimiento con aprendizaje, abordando temas como ciencia, historia y artes a través de la magia.',
      features: [
        'Contenido pedagógico específico',
        'Adaptado por grupo de edad',
        'Temas de ciencia e historia',
        'Artes integradas a través de la magia',
        'Entretenimiento educativo'
      ]
    },
    {
      icon: 'ri-community-line',
      title: 'Performance Cultural',
      description: 'Versión condensada para eventos culturales, festivales y celebraciones comunitarias. Se enfoca en números de alto impacto visual y participación del público, adaptándose a diferentes espacios y contextos.',
      features: [
        'Formato condensado y dinámico',
        'Alto impacto visual',
        'Máxima participación del público',
        'Adaptable a diferentes espacios',
        'Ideal para festivales y celebraciones'
      ]
    },
    {
      icon: 'ri-tools-line',
      title: 'Taller de Ilusionismo',
      description: 'Actividad práctica que introduce a los participantes a los principios básicos del arte del ilusionimo, estimulando creatividad y coordinación. Ideal como complemento educativo o como actividad independiente en centros culturales y escuelas.',
      features: [
        'Actividad práctica e interactiva',
        'Principios básicos de la magia',
        'Estímulo a la creatividad',
        'Desarrollo de la coordinación',
        'Complemento educativo único'
      ]
    }
  ];

  return (
    <section id="services" className="py-20 bg-gradient-to-b from-black via-gray-900 to-black">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="font-elegant text-4xl md:text-5xl font-bold text-white mb-6">
            Servicios <span className="text-red-600">Mágicos</span>
          </h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">
            Desde presentaciones íntimas hasta grandes espectáculos, ofrezco experiencias mágicas personalizadas que combinan entretenimiento de calidad con mensajes educativos y valores positivos.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              icon={service.icon}
              title={service.title}
              description={service.description}
              features={service.features}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
